interface Data {
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  eventValue?: string;
  [key: string]: unknown;
}

export const push = (data: Data) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }
  window.dataLayer.push({
    event: 'autoEvent',
    eventLabel: '',
    eventValue: '',
    ...data,
  });
};

export const pushVariables = (data: {}) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }
  window.dataLayer.push(data);
};
